import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
    status: number;
    data?: any;
    message: string;
};

export const subAdminApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getRoles: builder.query<
            CommonResponse,
            { search: string; page: number }
        >({
            query: ({ search, page }) => ({
                url: `${END_POINTS.getRoles}?search=${search}&pageSize=${10}&pageNumber=${page}`,
                method: "GET",
            }),
        }),

        addRole: builder.mutation<CommonResponse, any>({
            query: (body) => ({
                url: END_POINTS.createRole,
                method: "POST",
                body,
            }),
        }),

        deleteRole: builder.query<CommonResponse, { id: string }>({
            query: ({ id }) => ({
                url: `${END_POINTS.deleteRole}/${id}`,
                method: "DELETE",
            }),
        }),

        changeRoleStatus: builder.query<CommonResponse, { id: string }>({
            query: ({ id }) => ({
                url: `${END_POINTS.roleStatus}/${id}`,
                method: "GET",
            }),
        }),

        roleById: builder.query<CommonResponse, { id: string | undefined }>({
            query: ({ id }) => ({
                url: `${END_POINTS.getRoleById}/${id}`,
                method: "GET",
            }),
        }),

        createSubAdmin: builder.mutation<CommonResponse, any>({
            query: (body) => ({
                url: END_POINTS.createSubAdmin,
                method: "POST",
                body,
            }),
        }),

        getSubAdmin: builder.query<
            CommonResponse,
            { search: string; page: number }
        >({
            query: ({ search, page }) => ({
                url: `${END_POINTS.getSubAdmins}?search=${search}&pageSize=${10}&pageNumber=${page}`,
                method: "GET",
            }),
        }),

        deleteSubAdmin: builder.query<CommonResponse, { id: string }>({
            query: ({ id }) => ({
                url: `${END_POINTS.deleteSubAdmin}/${id}`,
                method: "DELETE",
            }),
        }),

        subAdminById: builder.query<CommonResponse, { id: string | undefined }>({
            query: ({ id }) => ({
                url: `${END_POINTS.getSubAdminById}/${id}`,
                method: "GET",
            }),
        }),

        updateSubAdmin: builder.mutation<CommonResponse, any>({
            query: (body) => ({
                url: END_POINTS.editSubAdmin,
                method: "PUT",
                body,
            }),
        }),

    }),
});

export const {
    useLazyGetRolesQuery,
    useAddRoleMutation,
    useLazyDeleteRoleQuery,
    useLazyChangeRoleStatusQuery,
    useLazyRoleByIdQuery,
    useCreateSubAdminMutation,
    useLazyGetSubAdminQuery,
    useLazyDeleteSubAdminQuery,
    useLazySubAdminByIdQuery,
    useUpdateSubAdminMutation
} = subAdminApi;
